import type { WricefCatalogQuery } from "@/types/wricef";

/**
 * O que a lista mostra, traduzido em filtro da api (#1083).
 *
 * São três eixos diferentes atrás de um controle só, porque a pergunta de quem
 * olha é uma ("o que estou vendo?"). O estado do Guia separa entregável de
 * peça pelo TIPO. A lista sem executável é por ALCANCE: a peça cujo dono é
 * outra peça que ninguém chama também entra. E o gerado pelo SAP é pelo PAPEL:
 * pelo tipo ele é peça, mas o dono dele é a transação que o gera.
 */
export function listViewQuery(view: string): Partial<WricefCatalogQuery> {
  if (view === "all") return {};
  if (view === "without_executable") return { without_executable: true };
  if (view === "generated") return { unit_role: ["configuracao"] };
  return { object_state: [view] };
}
